import React from 'react';
import { LinkType } from '@tcs/create-account/utils/prismic/types';
import { getDocumentRouteById } from '@tcs/create-account/utils/prismic/helpers';
import { Routes } from '@tcs/create-account/utils/routes';

interface LinkProps {
  link: LinkType | string;
  className?: string;
  label?: string;
  target?: '_blank' | '_self';
  children: React.ReactNode;
}

const Link: React.FC<LinkProps> = ({
  link,
  className,
  children,
  label,
  target,
}) => {
  if (typeof link === 'string') {
    return (
      <a
        href={link}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : ''}
        className={className}
        aria-label={label}>
        {children}
      </a>
    );
  }
  const { url, link_type, uid } = link;

  const notFoundLink = (
    <a
      className={className}
      href={Routes.NOT_FOUND.route}
      rel="nofollow"
      aria-label={label}>
      {children}
    </a>
  );

  if (link_type === 'Web') {
    if (!url) {
      return notFoundLink;
    }

    return (
      <a
        href={url}
        target={link.target}
        rel={link.target === '_blank' ? 'noopener noreferrer' : ''}
        className={className}
        aria-label={label}>
        {children}
      </a>
    );
  }

  if (link_type === 'Media') {
    if (!url) {
      return notFoundLink;
    }

    return (
      <a
        href={url}
        target={'_blank'}
        rel={'noopener noreferrer'}
        className={className}
        aria-label={label}
        download>
        {children}
      </a>
    );
  }

  if (link_type === 'Document') {
    if (!uid) return notFoundLink;
    const definedUrl = getDocumentRouteById(uid);
    if (definedUrl) {
      return (
        <a className={className} href={definedUrl}>
          {children}
        </a>
      );
    }
  }

  return notFoundLink;
};

export default Link;
